<script setup>
defineProps({
  label: {
    type: String,
    default: 'Button'
  },
  icon: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <pv-button
    :label="label"
    :icon="icon"
    size="small"
    color="primary"
    :disabled="disabled"
    class="w-full sm:w-auto"
  >
    <slot></slot>
  </pv-button>
</template>
